import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import config from '~/config';

let cachedAxios: AxiosInstance | undefined = undefined;
let mockedAxiosInitialized = false;

function withDelay(delay: number, responseCallback: ResponseCallback): CallbackResponseSpecFunc {
  return async (config: AxiosRequestConfig) => {
    console.info(`Requesting ${config.url}`);
    await new Promise((resolve) => setTimeout(resolve, delay));
    const { status, data } = responseCallback(config);
    return [status, data];
  };
}

export async function getAxios() {
  if (!config.MOCK_REQUESTS) return axios;
  if (cachedAxios && mockedAxiosInitialized) return cachedAxios;

  cachedAxios = axios.create();
  const mock = new MockAdapter(cachedAxios);

  const mocks = await import('./mock');

  const delay = 700;
  for (const { method, path, response } of mocks.default) {
    if (method === 'POST') mock.onPost(path).reply(withDelay(delay, response));
    if (method === 'GET') mock.onGet(path).reply(withDelay(delay, response));
    if (method === 'PUT') mock.onPut(path).reply(withDelay(delay, response));
    if (method === 'DELETE') mock.onDelete(path).reply(withDelay(delay, response));
    if (method === 'PATCH') mock.onPatch(path).reply(withDelay(delay, response));
  }
  mockedAxiosInitialized = true;

  return cachedAxios;
}

type CallbackResponseSpecFunc = (config: AxiosRequestConfig) => any[] | Promise<any[]>;

type ResponseCallback = (config: AxiosRequestConfig) => { status: number; data: any };
